import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import LensIcon from "@material-ui/icons/Lens";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import { joinClasses } from "@utils/materialUI";
import { familyPath } from "@utils/router";

const useStyles = makeStyles(() => ({
  item: {
    marginBottom: "4px",
  },
  itemLink: {
    display: "flex",
    alignItems: "center",
    height: "44px",
    paddingLeft: "16px",
    paddingRight: "16px",
    borderRadius: "4px",
    textDecoration: "none",
    userSelect: "none",

    "&:hover": {
      background: "rgba(255, 255, 255, 0.1)",
    },

    "&:active": {
      background: "rgba(255, 255, 255, 0.2)",
    },
  },
  itemLinkActive: {
    background: "rgba(255, 255, 255, 0.1)",
  },
  itemLinkIcon: {
    color: "#ffffff",
    fontSize: "0px",
  },
  itemLinkLabel: {
    display: "block",
    paddingLeft: "16px",
    color: "#ffffff",
  },
}));

function SideMenuItemLink(props) {
  const history = useHistory();
  const classes = useStyles();

  const { to, onActive, onInactive } = props;
  const [active, setActive] = useState(false);

  useEffect(() => {
    function checkActiveItem() {
      if (familyPath(to)) {
        setActive(true);
        onActive();
      } else {
        setActive(false);
        onInactive();
      }
    }

    checkActiveItem();

    const unlistenHistory = history.listen(() => {
      checkActiveItem();
    });

    return () => {
      unlistenHistory();
    };
  }, [history, to, onActive, onInactive]);

  return (
    <div className={classes.item}>
      <Link
        to={props.to}
        className={joinClasses(classes.itemLink, {
          [classes.itemLinkActive]: active,
        })}
      >
        <div className={classes.itemLinkIcon}>
          {props.level === 1 &&
            React.createElement(props.icon, { fontSize: "small" })}
          {props.level === 2 && (
            <LensIcon style={{ fontSize: "6px", margin: "7px" }} />
          )}
        </div>
        <Typography variant="body2" className={classes.itemLinkLabel}>
          {props.label}
        </Typography>
      </Link>
    </div>
  );
}

SideMenuItemLink.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  level: PropTypes.number,
  icon: PropTypes.any,
  onActive: PropTypes.func,
  onInactive: PropTypes.func,
};

SideMenuItemLink.defaultProps = {
  label: "",
  to: "",
  level: 1,
  icon: null,
  onActive: () => {},
  onInactive: () => {},
};

export default SideMenuItemLink;
